export enum ButtonType {
    SMALL = 'small',
    LARGE = 'large'
}

export interface WalletAddressProps {
    id?: string;
    className?: string;
    isAdmin: boolean;
    walletAddress: string;
    buttonType?: ButtonType.SMALL | ButtonType.LARGE;
}